<template>
    <div class="message-item__content--audio-player">
        <div class="file file__audio">
            <div class="file__icon">
                <icon name="audio" type="png" :width="72" :height="68" />
            </div>
            <div class="file__info">
                <div class="audio_wrap">
                    <p class="name">{{ media.name }}</p>
                    <div class="slider" ref="slider">
                        <div class="process" :style="{width}"></div>
                        <div class="trunk" ref="trunk" :style="{left}">
                            <div class="block"></div>
                        </div>
                    </div>
                    <div class="duration">
                        <span>{{ currentTime }}</span>
                        <span>{{ allTime }}</span>
                    </div>
                </div>
                <span :class="['audio_icon', playing ? 'icon_audio_pause' : 'icon_audio_play']" @click="playAudio"></span>
            </div>
        </div>
        <audio ref="audioPlayer"
            :src="media.url"
            @canplaythrough="canplaythrough"
            @timeupdate="timeupdate"
            @ended="ended"
            @pause="paused" />
    </div>
</template>

<script>
    import Icon from '@/components/Icon'
    import { offsetByBody, stopAllAudio } from '@/utils/dom'
    import { time2Ms } from '@/utils/index'

    export default {
        name: 'MessageContentAudioPlayer',
        props: {
            messageId: {
                type: String,
                required: true
            },
            media: {
                required: true,
                type: Object
            }
        },
        data () {
            return {
                audioPlayer: null, // audio实例
                slider: null, // 进度条
                trunk: null, // 拖拽块
                duration: 1, // 时长
                allTime: '00:00', // 总时间
                currentTime: '00:00', // 当前时间
                per: 0, // 进度条
                min: 0,
                max: 110, // 进度条最大长度
                isDrag: false, // 正在拖拽
                playing: false // 是否在播放
            }
        },
        computed: {
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            // 设置一个百分比，提供计算slider进度宽度和trunk的left值
            // 对应公式为：当前值-最小值/最大值-最小值 = slider进度width / slider总width
            // trunk left =  slider进度width + trunk宽度/2

            // 进度百分比
            scale () {
                return (this.per - this.min) / (this.max - this.min)
            },
            // 进度条width
            width () {
                if (this.slider) {
                    return this.slider.offsetWidth * this.scale + 'px'
                } else {
                    return '0px'
                }
            },
            // 滑块left
            left () {
                if (this.slider) {
                    return this.slider.offsetWidth * this.scale - this.trunk.offsetWidth / 2 + 'px'
                } else {
                    return '0px'
                }
            }
        },
        created () {
            this.max = this.isDesktop ? 250 : 110
        },
        mounted () {
            let that = this

            if (this.$refs.audioPlayer) this.audioPlayer = this.$refs.audioPlayer
            if (this.$refs.slider) this.slider = this.$refs.slider
            if (this.$refs.trunk) this.trunk = this.$refs.trunk

            // 兼容移动 和 PC端的事件
            const touch = 'ontouchstart' in window
            const bindTouchstart = touch ? 'ontouchstart' : 'onmousedown'
            const bindTouchmove = touch ? 'ontouchmove' : 'onmousemove'
            const bindTouchend = touch ? 'ontouchend' : 'onmouseup'

            // 拖动小滑块
            this.trunk[bindTouchstart] = function (evt) {
                let e = touch ? evt.touches[0] : evt
                let width = parseInt(that.width)
                let disX = e.clientX

                document[bindTouchmove] = function (e) {
                    e = touch ? e.touches[0] : e
                    that.isDrag = true
                    // value, left, width
                    // 当value变化的时候，会通过计算属性修改left，width

                    // 拖拽的时候获取的新width
                    let newWidth = e.clientX - disX + width
                    // 拖拽的时候得到进度条的百分比
                    let scale = newWidth / that.slider.offsetWidth
                    let _per = Math.ceil((that.max - that.min) * scale + that.min)
                    _per = Math.max(_per, that.min)
                    _per = Math.min(_per, that.max)
                    that.per = _per
                    // console.log(`${that.per}px`)
                }

                document[bindTouchend] = function () {
                    document[bindTouchmove] = document[bindTouchend] = null
                    that.progressChange()
                    that.isDrag = false
                }
                return false
            }
            // 点击进度条
            this.slider[bindTouchstart] = function (evt) {
                evt.stopPropagation()
                evt.preventDefault()
                let e = touch ? evt.touches[0] : evt
                that.isDrag = true
                let newWidth = e.clientX - offsetByBody(this, 'left')
                let scale = newWidth / that.slider.offsetWidth
                let _per = Math.ceil((that.max - that.min) * scale + that.min)
                _per = Math.max(_per, that.min)
                _per = Math.min(_per, that.max)
                that.per = _per
                // console.log(`${that.per}px`)
                that.progressChange()
                that.isDrag = false
            }
        },
        methods: {
            canplaythrough (e) {   
                this.duration = e.target.duration || this.media.duration
                this.allTime = time2Ms(this.duration)
            },
            ended () {
                console.log('audio is ended!')
                this.playing = false
                let totalLength = this.slider.offsetWidth
                this.per = totalLength
            },
            paused () {
                console.log('audio is paused!')
                this.playing = false
            },
            timeupdate () {
                console.log('is playing...')
                if(this.isDrag) return false  // 拖动时per不随播放时间变化
                let currentTime = this.audioPlayer.currentTime
                let totalLength = this.slider.offsetWidth
                this.per = totalLength * (currentTime / this.duration) // per随播放时间更新
                this.currentTime = time2Ms(currentTime)
                // console.log(`进度条：${this.per}px`, `播放：${currentTime}s`)
            },
            // 改变进度条后重新设置currentTime
            progressChange () {
                let currentTime = this.duration * this.scale
                this.audioPlayer.currentTime = currentTime
                this.currentTime = time2Ms(currentTime)
                // console.log(`播放：${this.audioPlayer.currentTime}s`)
            },
            // 播放或暂停
            playAudio () {
                let audio =  this.audioPlayer
                if(this.playing) { // 当前音频播放中，暂停
                    this.playing = false
                    audio.pause()
                } else { // 当前音频未播放，继续播放
                    stopAllAudio(false) // 停止其他音频
                    if(audio.ended) { // 已结束，时间重置
                        audio.currentTime = 0
                        this.currentTime = '00:00'
                    }
                    audio.play()
                    this.playing = true
                }
            }
        },
        components: {
            Icon
        }
    }
</script>

<style lang="scss" scoped>
    $mobileWidth: 110px;
    $pcWidth: 250px;

    .file {
        display: flex;
        justify-content: space-between;
        height: 68px;
        width: 254px;
        background-color: #fff;
        box-shadow: $primary-box-shadow;
        overflow: hidden;
        cursor: pointer;
        @include radius(.25, .5, .5, .5);

        @include desktop {
            width: 400px;
        }

        &__icon {
            width: 72px;
            height: 68px;
        }

        &__info {
            width: calc(100% - 72px);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 15px;
            
            .audio_wrap {
                width: $mobileWidth;

                @include desktop {
                    width: $pcWidth;
                }

                .name {
                    font-size: 14px;
                    color: $primary-text-color;
                    line-height: 20px;
                    @include text-line(1);
                }
                .duration {
                    font-size: 12px;
                    color: #919294;
                    line-height: 1;
                    display: flex;
                    justify-content: space-between;
                }
            }

            .audio_icon {
                display: inline-block;
                font-size: 30px;
                width: 30px;
                height: 30px;
                margin-left: 10px;
                color: $primary-color;
                cursor: pointer;
            }
        }
    }


    // 进度条
    .slider {
        position: relative;
        width: $mobileWidth;
        height: 3px;
        margin: 10px 0;
        background: #E6E6E6;
        border-radius: 1px;
        cursor: pointer;

        @include desktop {
            width: $pcWidth;
        }

        .process {
            position: absolute;
            left: 0;
            top: 0;
            height: 3px;
            border-radius: 1px;
            background: $primary-color;
        }
        .trunk {
            position: absolute;
            left: 0;
            top: -5px;
            width: 12px;
            height: 12px;
        }
        .block {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 4px solid $primary-color;
            background: #ffffff;
            transition: 0.2s all;
            &:hover, &:active {
                transform: scale(1.2);
            }
        }
    }

</style>
